export default "__VITE_ASSET__D6YT579J__"